import React from 'react';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { ContactItem } from './ContactItem';
// import { WEBSITE_LINKS } from '@/constants/routes';

export function ContactInfo() {
    return (
        <div>
            <div className="flex items-center mb-8">
                <img
                    src="/images/IIT-Challenge-Logo-2025.png"
                    alt="Logo"
                    className="w-32 h-16 object-contain"
                />
            </div>

            <ContactItem icon={faLocationDot} >
                Brooklyn Office Tower B, 7th Floor, Unit P. Alam Sutera Boulevard. Banten, Indonesia
            </ContactItem>

            <ContactItem icon={faEnvelope}>
                support@iitchallenge.com
            </ContactItem>

            <ContactItem icon={faPhone}>
                <div className="flex flex-col gap-2">
                    <a
                            className="text-sm md:text-base"
                            target="_blank"
                            rel="noreferrer"
                            href="https://wa.me/6287808786357"
                        >
                            +62 878-0878-6357 (Annabel Oktaviani Putri)
                        </a>
                    <a
                            className="text-sm md:text-base"
                            target="_blank"
                            rel="noreferrer"
                            href="https://wa.me/6281382137539"
                        >
                            +62 813-8213-7539 (Chilva Almira Rizqi)
                        </a>
                    <a
                            className="text-sm md:text-base"
                            target="_blank"
                            rel="noreferrer"
                            href="https://wa.me/6281372529119"
                        >
                            +62 813-7252-9119 (Jessen William)
                        </a>
                </div>
            </ContactItem>

            {/* <ContactItem icon={faGlobe} align="start">
                <div className="flex flex-col gap-2">
                    {WEBSITE_LINKS.map((website, index) => (
                        <a
                            key={index}
                            className="text-sm md:text-base"
                            target="_blank"
                            rel="noreferrer"
                            href={website.href}
                        >
                            {website.label}
                        </a>
                    ))}
                </div>
            </ContactItem> */}
        </div>
    );
}
